/*
 * @Author: cn1994
 * @Date: 2024-06-05 17:45:16
 * @LastEditors: cn1994
 * @LastEditTime: 2024-06-05 17:47:27
 * @Description: 请假模块
 */
const routes = [
  {
    path: '/leave',
    name: 'leave',
    meta: {
      title: '请假管理',
      volcengine: true,
    },
    component: () => import('../pages/leave/management/index.vue'),
  },
]
export default routes